import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { getSearchResults } from '../helpers/api/search';

export const useCmsAiStore = defineStore('cmsAi', () => {
  const cmsAiSettings = ref({
    ai_chat_enabled: false,
    ai_search_enabled: false,
    tasks_enabled: false,
    display_ai_chat: false,
  });
  const clientId = ref(null);
  const searchUUID = ref(null);
  const sessionId = ref(null);

  const getCmsAiSettings = computed(() => cmsAiSettings.value);
  const getSearchUUID = computed(() => searchUUID.value);
  const getSessionId = computed(() => sessionId.value);

  function setCmsAiSettings(payload) {
    cmsAiSettings.value = payload;
  }
  function setClientId(id) {
    clientId.value = id;
  }
  function setSearchUUID(uuid) {
    searchUUID.value = uuid;
  }
  function setSessionId(value) {
    sessionId.value = value;
  }

  async function getSearchResultsAction({
    term,
    searchByCurrentOrg,
    selectedFilters,
    startDate,
    endDate,
    orgIds = null,
    translate = false,
  }) {
    const { useMainStore } = await import('./mainStore.js');
    const mainStore = useMainStore();
    const { useTranslationStore } = await import('./translationStore.js');
    const translationStore = useTranslationStore();
    const locale = translate ? translationStore.locale : undefined;

    const response = await getSearchResults({
      term,
      secondaryOrgId: mainStore.secondaryOrgId,
      searchByCurrentOrg,
      selectedFilters,
      orgIds,
      startDate,
      endDate,
      locale,
    });

    const queryId = response.config?.params?.query_id;
    const responseSessionId = response.config?.params?.session_id;

    if (queryId) setSearchUUID(queryId);
    if (responseSessionId) setSessionId(responseSessionId);

    return response;
  }

  return {
    cmsAiSettings,
    clientId,
    searchUUID,
    sessionId,
    getCmsAiSettings,
    getSearchUUID,
    getSessionId,
    setCmsAiSettings,
    setClientId,
    setSearchUUID,
    setSessionId,
    getSearchResults: getSearchResultsAction,
  };
});
